// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","logoutButton":"menu_logoutButton__oxNqD"};